import axios from 'axios';

export async function login(email, password) {
  const res = await axios.post('/auth/login', { email, password });
  return res.data; // { id_token, refresh_token }
}

export async function signup(email, password) {
  const res = await axios.post('/auth/signup', { email, password });
  return res.data; // { user_sub, confirmed, message }
}

export async function confirmEmail(email, code) {
  const res = await axios.post('/auth/confirm_signup', { email, code });
  return res.data;
}

export async function resendCode(email) {
  const res = await axios.post('/auth/resend_code', { email });
  return res.data;
}

export async function forgotPassword(email) {
  const res = await axios.post('/auth/forgot_password', { email });
  return res.data;
}

export async function confirmForgotPassword(email, code, newPassword) {
  const res = await axios.post('/auth/confirm_forgot_password', { email, code, new_password: newPassword });
  return res.data;
}

export async function changePassword(oldPassword, newPassword) {
  // Uses Authorization header (id_token) already set on axios defaults
  const res = await axios.post('/auth/change_password', {
    previous_password: oldPassword,
    new_password: newPassword,
  });
  return res.data;
}

export async function refreshSession(refreshToken) {
  const res = await axios.post('/auth/refresh', { refresh_token: refreshToken });
  return res.data; // { id_token }
}

export function logout() {
  // No Cognito SDK call needed — just clear local state
  delete axios.defaults.headers.common['Authorization'];
}
